// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"936608b3","179":"c0c556a0","215":"9b7d0731","478":"d8c624b9","691":"b23c6588","842":"8b00cdb5"}[chunkId] + ".chunk.js";
};